import { isNonMobileWeb, View, WorkflowStepIndicator } from 'smoothie';

import { useMoneyMapWorkflow } from '../hooks/useMoneyMapWorkflow';
import type { GoWorkflowStepType } from '../types/GoWorkflow';
import { RoadmapScreenHeader } from './RoadmapScreenHeader';

export const GoWorkflowHeader = ({
    stepType,
    title,
    hasBackButton = true,
    onBack,
}: {
    stepType?: GoWorkflowStepType;
    title?: string;
    hasBackButton?: boolean;
    hasMessagingButton?: boolean;
    onBack?: () => void;
}) => {
    const { workflowSteps } = useMoneyMapWorkflow();
    const step = workflowSteps.find((step) => {
        return step.type === stepType;
    });

    return (
        <RoadmapScreenHeader
            title={title}
            hasMessagingButton={false}
            hasBackButton={hasBackButton}
            onBack={onBack}
            contentAboveTitle={
                <View
                    flex={1}
                    width="100%"
                    maxWidth={700}
                    alignSelf="center"
                    paddingBottom={isNonMobileWeb ? 8 : 24}
                >
                    <WorkflowStepIndicator
                        currentStepIndex={step?.index}
                        totalStepCount={workflowSteps.length}
                    />
                </View>
            }
        />
    );
};
